/**
 * Validate a feed schedule (aka 'retention policy' or 'culling schedule')
 */
export const feedValidateScheduleSpec = {
    uri: '/t/[tenant]/feed/validate-schedule',
    method: 'POST',
};
